import { ITabItem } from './types';
import { EPageType } from '../../../types/page/pageType';
import homeownerImg from '../assets/homeowner.svg';
import tenantImg from '../assets/tenant.svg';

export const TABS: ITabItem[] = [
  {
    value: EPageType.Tenant,
    label: 'Для арендатора',
    img: tenantImg,
  },
  {
    value: EPageType.Homeowner,
    label: 'Для собственника',
    img: homeownerImg,
  },
];
